import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import parallaxImg from "@/assets/vision-parallax.png";
import bannerImg from "@/assets/dholera-vision.png";

export default function VisionBanner() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const imgY = useTransform(scrollYProgress, [0, 1], ["-12%", "12%"]);

  return (
    <>
      <section
        ref={ref}
        className="relative block h-[440px] w-full overflow-hidden md:h-[560px]"
        data-testid="vision-banner-section"
      >
        <motion.img
          src={parallaxImg}
          alt="Smart City Dholera — future skyline vision"
          style={{ y: imgY }}
          className="absolute inset-0 h-[124%] w-full -translate-y-[10%] object-cover"
        />
        <div className="absolute inset-0 bg-black/55" aria-hidden="true" />
        <div
          className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-black/30"
          aria-hidden="true"
        />

        <div className="relative z-10 flex h-full items-center justify-center px-5 md:px-10">
          <div className="mx-auto max-w-4xl text-center">
            <motion.p
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6 }}
              className="font-mono text-[10px] uppercase tracking-[0.4em] text-accent"
              data-testid="vision-banner-eyebrow"
            >
              The Dholera Vision
            </motion.p>
            <motion.h2
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: 0.1 }}
              className="mt-5 font-display text-3xl font-extrabold uppercase leading-[1.05] tracking-tight text-white sm:text-4xl lg:text-5xl"
              data-testid="vision-banner-heading"
            >
              The biggest wealth opportunities
              <br className="hidden sm:block" /> are created before the boom.
            </motion.h2>
            <motion.p
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: 0.25 }}
              className="mx-auto mt-6 max-w-xl font-mono text-xs uppercase tracking-[0.25em] text-white/75 sm:text-sm"
              data-testid="vision-banner-subheading"
            >
              Smart Vision. Sustainable Living. Limitless Growth.
            </motion.p>
          </div>
        </div>
      </section>

      <section
        className="relative -mt-px block w-full"
        data-testid="vision-full-banner-section"
      >
        <img
          src={bannerImg}
          alt="Future is Smart City Dholera — a new era of progress"
          className="block h-auto w-full"
        />
      </section>
    </>
  );
}
